import InviraUserManagementPage from './index.vue'
export {InviraUserManagementPage}
export default InviraUserManagementPage

